<template>
    <div id="plannerstudentprogress">
        <div class="admin-wrap">
            <div class="row header mb-5">
                <div class="col-lg-6">
                    <h3 class="text-left mb-3">
                        {{lang("Student")}}{{lang("Progress")}}
                    </h3>
                </div>
                <div class="col-lg-6 actionDiv">
                    <el-select v-model="ddlSemester" @change="BindSemesterDetails()" :placeholder="lang('Select Academic Year')">
                        <el-option
                                v-for="item in ddlSemesterList"
                                :key="item.SemesterID"
                                :label="item.SemesterName"
                                :value="item.SemesterID">
                        </el-option>
                    </el-select>

                    <el-select v-model="ddlSemesterDetails" @change="ChangeSemesterDetails()" :placeholder="lang('Select Term')">
                        <el-option
                                v-for="item in ddlSemesterDetailsList"
                                :key="item.SemesterDetailsID"
                                :label="item.SemesterDetailsName"
                                :value="item.SemesterDetailsID">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="pb-5">
                <div class="empty-list_image" v-if="!studentLearningMomentProgressListRecords">
                    <strong>{{startupText}}</strong>
                    <img src="../assets/notfound.png"/>
                </div>
                <div style="text-align: left;font-size: 20px;" v-if="currentStudentFullName !== ''">
                    <label>{{currentStudentFullName}}</label>
                </div>
                <div v-if="studentLearningMomentProgressListRecords">
                    <div class="row divBtnShowhideWholeYear">
                        <div class="col-lg-12">
                            <el-button type="primary" class="mt-2 mb-2" @click="showhideWholeYear()">
                                {{lang(showhideWholeYearText)}}
                            </el-button>
                        </div>
                    </div>

                    <div class="row divWholeYear" v-if="showWholeYear">
                        <div class="col-lg-6">
                            <label class="partTitle">{{lang("Learning goal documented for this academic year")}}</label>
                            <div v-if="postedDomainChart.labels.length<1">
                                <label>{{lang("No learning goal documented")}}...</label>
                            </div>
                            <div v-if="postedDomainChart.labels.length>0">
                                <div>
                                    <pie-chart
                                        :chartdata="postedDomainChart"
                                    />
                                </div>
                                <div class="radarChart">
                                    <radarChart
                                        :chartdata="postedDomainChart"
                                    />
                                </div>
                                <div>
                                    <label class="partTitle">{{lang("Learning goal documented Summary")}}</label>
                                    <div v-if="postedDomainChart.labels.length>0">
                                        <div v-for="item in postedDomainSummary">
                                            <!-- label>{{item.Domain}} : Posted {{item.PostedCount}} out of {{item.Total}}, Percentage {{item.DonePercentage}}%</label -->
											<label>{{item.Domain}} : {{item.PostedCount}} out of {{item.Total}} learning goal documented</label>
                                        </div>
                                    </div>
<!--                                    <div>-->
<!--                                        <el-button type="primary" round @click="openPostedDomainDetailsModal()">{{lang("View More Details")}}...</el-button>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <label class="partTitle">{{lang("Learning goals to be documented for this academic year")}}</label>
                            <div v-if="pendingDomainChart.labels.length<1">
                                <label>{{lang("No learning goals to be documented")}}...</label>
                            </div>
                            <div v-if="pendingDomainChart.labels.length>0">
                                <div>
                                    <pie-chart
                                        :chartdata="pendingDomainChart"
                                    />
                                </div>
                                <div class="radarChart">
                                    <radarChart
                                            :chartdata="pendingDomainChart"
                                    />
                                </div>
                                <div>
                                    <label class="partTitle">{{lang("Learning goals to be documented Summary")}}</label>
                                    <div v-if="pendingDomainChart.labels.length>0">
                                        <div v-for="item in pendingDomainSummary">
                                            <!-- label>{{item.Domain}} : Pending {{item.PendingCount}} out of {{item.Total}}, Percentage {{item.UnDonePercentage}}%</label -->
                                            <label>{{item.Domain}} : {{item.PendingCount}} out of {{item.Total}} learning goals to be documented </label>
                                        </div>
                                    </div>
<!--                                    <div>-->
<!--                                        <el-button type="primary" round @click="openPendingDomainDetailsModal()">{{lang("View More Details")}}...</el-button>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6">
                            <label class="partTitle">{{lang("Learning goal documented")}}</label>
                            <div v-if="postedDomainByTermChart.labels.length<1">
                                <label>{{lang("No learning goal documented")}}...</label>
                            </div>
                            <div v-if="postedDomainByTermChart.labels.length>0">
                                <div>
                                    <pie-chart
                                            :chartdata="postedDomainByTermChart"
                                    />
                                </div>
                                <div class="radarChart">
                                    <radarChart
                                            :chartdata="postedDomainByTermChart"
                                    />
                                </div>
                                <div>
                                    <label class="partTitle">{{lang("Learning goal documented Summary")}}</label>
                                    <div v-if="postedDomainByTermChart.labels.length>0">
                                        <div v-for="item in postedDomainByTermSummary">
                                            <!-- label>{{item.Domain}} : Posted {{item.PostedCount}} out of {{item.Total}}, Percentage {{item.DonePercentage}}%</label -->
											<label>{{item.Domain}} : {{item.PostedCount}} out of {{item.Total}} learning goal documented </label>
                                        </div>
                                    </div>
<!--                                    <div>-->
<!--                                        <el-button type="primary" round @click="openPostedDomainByTermDetailsModal()">{{lang("View More Details")}}...</el-button>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6">
                            <label class="partTitle">{{lang("Learning goals to be documented")}}</label>
                            <div v-if="pendingDomainByTermChart.labels.length<1">
                                <label>{{lang("No learning goals to be documented")}}...</label>
                            </div>
                            <div v-if="pendingDomainByTermChart.labels.length>0">
                                <div>
                                    <pie-chart
                                            :chartdata="pendingDomainByTermChart"
                                    />
                                </div>
                                <div class="radarChart">
                                    <radarChart
                                            :chartdata="pendingDomainByTermChart"
                                    />
                                </div>
                                <div>
                                    <label class="partTitle">{{lang("Learning goals to be documented Summary")}}</label>
                                    <div v-if="pendingDomainByTermChart.labels.length>0">
                                        <div v-for="item in pendingDomainByTermSummary">
                                            <!-- label>{{item.Domain}} : Pending {{item.PendingCount}} out of {{item.Total}}, Percentage {{item.UnDonePercentage}}%</label -->
                                          <label>{{item.Domain}} : {{item.PendingCount}} out of {{item.Total}} learning goals to be documented </label>
											
                                        </div>
                                    </div>
<!--                                    <div>-->
<!--                                        <el-button type="primary" round @click="openPendingDomainByTermDetailsModal()">{{lang("View More Details")}}...</el-button>-->
<!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="postedReportDiv">
                        <div>
                            <label class="partTitle">{{lang("Tracker")}}</label>
                        </div>
                        <div class="studentLearningMomentProgressTable">
                            <table>
                                <thead>
                                    <tr>
                                        <th v-for="(header, index) in studentLearningMomentProgressListValue" v-if="index !== 1">
                                            <div v-if="index === 0">

                                            </div>
                                            <div v-if="index !== 0 && index !== 1">
                                                {{header.label}}
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <!--<tbody>-->
                                    <!--<tr v-for="detials in studentLearningMomentProgressList" :class="{'domainTr':detials.isDomain}">-->
                                        <!--<td v-for="(detialsValue, detialsValueKey, detialsValueIndex) in detials" v-if="detialsValueKey !== 'isDomain'">-->
                                            <!--<div v-if="detialsValueKey === 'Domain'"-->
                                                 <!--:class="{'domainDiv':detials.isDomain}">-->
                                                <!--{{detialsValue}}-->
                                            <!--</div>-->
                                            <!--<div v-if="detialsValueKey !== 'Domain' && detialsValueKey !== 'isDomain'">-->
                                            <!--<span v-for="KeySkillOrCLD in detialsValue" class="keySkillCLDSpan" @click="displayPost(KeySkillOrCLD.PostID);">-->
                                                <!--{{KeySkillOrCLD.Value}}-->
                                            <!--</span>-->
                                            <!--</div>-->
                                        <!--</td>-->
                                    <!--</tr>-->
                                <!--</tbody>-->
                                <tbody>
                                    <tr v-for="detials in studentLearningMomentProgressList" :class="{'domainTr':detials.isDomain}">
                                        <td v-for="(header, index) in studentLearningMomentProgressListValue" v-if="index !== 1">
                                            <div v-for="(detialsValue, detialsValueKey, detialsValueIndex) in detials" v-if="detialsValueKey === header.label && detialsValueKey === 'Domain'" :class="{'domainDiv':detials.isDomain}">
                                                {{detialsValue}}
                                            </div>
                                            <div v-for="(detialsValue, detialsValueKey, detialsValueIndex) in detials" v-if="detialsValueKey === header.label && detialsValueKey !== 'Domain'">
                                                <span v-for="Indicator in detialsValue" class="IndicatorSpan" @click="displayPost(Indicator.PostID);">
                                                    {{Indicator.Value}}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal size="lg" :title="lang('View')" ok-only ok-variant="secondary" hide-footer ref="postModal">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
<!--                <PostComponent-->
<!--                        :parent-post="object"-->
<!--                        @loadPosts="loadPosts"-->
<!--                        ref="pComponent"-->
<!--                        :hideComment="true"-->
<!--                        @loadingclose="loadingclose"-->
<!--                />-->
                <viewPortfolioComponent
                        :parent-post=postIDList
                />
            </div>
        </b-modal>
        <b-modal size="lg" :title="lang('Pending Domain Details Whole Academic Year')" ok-only ok-variant="secondary" hide-footer ref="pendingDomainDetailsModal">
            <div v-if="pendingDomainDetailsInt.length>0" class="datatable_group">
                <data-tables :data="pendingDomainDetailsInt">
                    <el-table-column v-for="viewDomainDetailsInfo in viewDomainDetails"
                                     :prop="viewDomainDetailsInfo.prop" :label="viewDomainDetailsInfo.label"
                                     :key="viewDomainDetailsInfo.prop" sortable="custom">
                    </el-table-column>
                </data-tables>
            </div>
        </b-modal>
        <b-modal size="lg" :title="lang('Posted Domain Details Whole Academic Year')" ok-only ok-variant="secondary" hide-footer ref="postedDomainDetailsModal">
            <div v-if="postedDomainDetailsInt.length>0" class="datatable_group">
                <data-tables :data="postedDomainDetailsInt">
                    <el-table-column v-for="viewDomainDetailsInfo in viewDomainDetails"
                                     :prop="viewDomainDetailsInfo.prop" :label="viewDomainDetailsInfo.label"
                                     :key="viewDomainDetailsInfo.prop" sortable="custom">
                    </el-table-column>
                </data-tables>
            </div>
        </b-modal>
        <b-modal size="lg" :title="lang('Pending Domain Details')" ok-only ok-variant="secondary" hide-footer ref="pendingDomainByTermDetailsModal">
            <div v-if="pendingDomainByTermDetailsInt.length>0" class="datatable_group">
                <data-tables :data="pendingDomainByTermDetailsInt">
                    <el-table-column v-for="viewDomainDetailsInfo in viewDomainDetails"
                                     :prop="viewDomainDetailsInfo.prop" :label="viewDomainDetailsInfo.label"
                                     :key="viewDomainDetailsInfo.prop" sortable="custom">
                    </el-table-column>
                </data-tables>
            </div>
        </b-modal>
        <b-modal size="lg" :title="lang('Posted Domain Details')" ok-only ok-variant="secondary" hide-footer ref="postedDomainByTermDetailsModal">
            <div v-if="postedDomainByTermDetailsInt.length>0" class="datatable_group">
                <data-tables :data="postedDomainByTermDetailsInt">
                    <el-table-column v-for="viewDomainDetailsInfo in viewDomainDetails"
                                     :prop="viewDomainDetailsInfo.prop" :label="viewDomainDetailsInfo.label"
                                     :key="viewDomainDetailsInfo.prop" sortable="custom">
                    </el-table-column>
                </data-tables>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import DataSource from "../data/datasource";
    import PostComponent from "../components/postCompnent";
    import pieChart from "../components/charts/pieChart.vue";
    import radarChart from "../components/charts/radarChart.vue";
    import Global from "../global";
    import Vue from 'vue';
    import {lang} from '../locale/index';
    import Cookies from "js-cookie";

    import viewPortfolioComponent from "../components/viewPortfolioComponent";

    export default {
        name: "PlannerStudentProgress",
        data() {
            return {
                startupText: lang('No record found')+'...',
                currentStudentID: '',
                currentStudentFullName: '',
                currentClassID: '',
                currentLevelType: '',
                showWholeYear: false,
                showhideWholeYearText: 'Show Whole Academic Year',

                studentLearningMomentProgressListRecords:  false,
                studentLearningMomentProgressList: [],
                studentLearningMomentProgressListValue: [],
                postIDList: [],

                plannerAssignedListInt: [],
                pendingDomainSummary: [],
                pendingDomainDetailsInt: [],
                postedDomainSummary: [],
                postedDomainDetailsInt: [],

                plannerAssignedByTermListInt: [],
                postedDomainByTermSummary: [],
                postedDomainByTermDetailsInt: [],
                pendingDomainByTermSummary: [],
                pendingDomainByTermDetailsInt: [],

                ddlSemester: '',
                ddlSemesterList: [],
                ddlSemesterDetails: '',
                ddlSemesterDetailsList: [],
                ddlSemesterDetailsFullList: [],

                pendingDomainChart: {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                },
                postedDomainChart: {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                },

                pendingDomainByTermChart: {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                },
                postedDomainByTermChart: {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                },

                // viewDomainDetails: [{
                //     prop: "Domain",
                //     label: lang("Domain")
                // }, {
                //     prop: "Goals",
                //     label: lang("Goals")
                // }, {
                //     prop: "Indicator",
                //     label: lang("Indicator")
                // }, {
                //     prop: "Done",
                //     label: lang("Done")
                // }],
                viewDomainDetails: [],
            }
        },
        components: {
            PostComponent,
            pieChart,
            viewPortfolioComponent,
            radarChart,
        },
        computed: {
            ChartBG:()=>Global.state.ChartBG,
            HoverChartBG:()=>Global.state.HoverChartBG,
        },
        async created()
        {


            // if (this.$route.params.studentID && this.$route.params.classID) {
            //     this.currentStudentID = this.$route.params.studentID;
            //     this.currentClassID = this.$route.params.classID;
            //
            //     this.getAllSemesterAndSemesterDetails();
            // } else {
            //     // this.$router.push('/Portfolio');
            //
            //     // test
            //     this.currentStudentID = 'STU202000143546';
            //     this.currentClassID = 'CLS201900028161';
            //
            //     this.getAllSemesterAndSemesterDetails();
            //     // test
            // }
          this.ppParamData = {};
          this.ppParamData.studentID = this.$route.params.studentID;
          this.ppParamData.classID = this.$route.params.classID;
          this.ppParamData.semdID = this.$route.params.semdID;
          this.ppParamData.semID = this.$route.params.semID;
          this.ppParamData.levelType = this.$route.params.levelType;
          this.ppParamData.StudentFullName = this.$route.params.StudentFullName;


          if (this.ppParamData !== undefined) {

                this.currentStudentID = this.ppParamData.studentID;
                this.currentClassID = this.ppParamData.classID;
                this.currentLevelType = this.ppParamData.levelType;
                this.currentStudentFullName = this.ppParamData.StudentFullName;

                this.getAllSemesterAndSemesterDetails();
                this.getStudentPlannerProgressByClassIDRange(this.ppParamData.semdID);
            } else {
                window.location.replace('/StaffMainPage');

                // // test
                // this.currentStudentID = 'STU202000143546';
                // this.currentClassID = 'CLS201900028161';
                //
                // this.getAllSemesterAndSemesterDetails();
                // this.getStudentPlannerProgressByClassIDRange('SEMD201900009603');
                // // test
            }
        },
        methods: {
            lang,
            async getStudentPlannerProgressByClassIDRange(semdID){
                try {
                    if (semdID === '') {
                        semdID = this.ddlSemesterDetails;
                    }

                    const response = await DataSource.shared.getStudentPlannerProgressByClassIDRange(this.currentClassID, this.currentStudentID, semdID);
                    console.log(response);
                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            console.log('Get Student Planner Progress By ClassID Range: Error!!');
                        } else if (response.code === '2') {
                            this.studentLearningMomentProgressListRecords = false;
                        } else {
                            this.studentLearningMomentProgressListRecords = true;

                            if(response.DomainMapping.Table.length < 1){
                                console.log('No mapping domain');
                            }
 
                            /*#region Posted info show at below part*/
                            //arrange the month to year
                            let AcademicYearMonthYearTemp = {
                                prop: 'Domain',
                                label: 'Domain',
                            };
                            this.studentLearningMomentProgressListValue.push(AcademicYearMonthYearTemp);

                            AcademicYearMonthYearTemp = {
                                prop: 'isDomain',
                                label: 'isDomain',
                            };
                            this.studentLearningMomentProgressListValue.push(AcademicYearMonthYearTemp);

                            let lastMonth = 0;

                            response.AcademicYearMonthYear.Table.forEach(aymyItem => {
                                let currentMonth = '';

                                if (aymyItem.Month === 1) {
                                    currentMonth = 'Jan';
                                } else if (aymyItem.Month === 2) {
                                    currentMonth = 'Feb';
                                } else if (aymyItem.Month === 3) {
                                    currentMonth = 'Mar';
                                } else if (aymyItem.Month === 4) {
                                    currentMonth = 'Apr';
                                } else if (aymyItem.Month === 5) {
                                    currentMonth = 'May';
                                } else if (aymyItem.Month === 6) {
                                    currentMonth = 'Jun';
                                } else if (aymyItem.Month === 7) {
                                    currentMonth = 'Jul';
                                } else if (aymyItem.Month === 8) {
                                    currentMonth = 'Aug';
                                } else if (aymyItem.Month === 9) {
                                    currentMonth = 'Sep';
                                } else if (aymyItem.Month === 10) {
                                    currentMonth = 'Oct';
                                } else if (aymyItem.Month === 11) {
                                    currentMonth = 'Nov';
                                } else if (aymyItem.Month === 12) {
                                    currentMonth = 'Dec';
                                }

                                let AcademicYearMonthYearTemp = {
                                    prop: currentMonth,
                                    label: currentMonth,
                                };

                                lastMonth = aymyItem.Month;

                                this.studentLearningMomentProgressListValue.push(AcademicYearMonthYearTemp);
                            });

                            //last month coz some academic year dont have 12 months: length 14 coz 12 months + Domain + isDomain
                            if (this.studentLearningMomentProgressListValue.length < 14) {
                                for (let i = this.studentLearningMomentProgressListValue.length; i < 14; i++) {
                                    lastMonth ++;
                                    let lastMonthConvert = '';

                                    if (lastMonth === 1) {
                                        lastMonthConvert = 'Jan';
                                    } else if (lastMonth === 2) {
                                        lastMonthConvert = 'Feb';
                                    } else if (lastMonth === 3) {
                                        lastMonthConvert = 'Mar';
                                    } else if (lastMonth === 4) {
                                        lastMonthConvert = 'Apr';
                                    } else if (lastMonth === 5) {
                                        lastMonthConvert = 'May';
                                    } else if (lastMonth === 6) {
                                        lastMonthConvert = 'Jun';
                                    } else if (lastMonth === 7) {
                                        lastMonthConvert = 'Jul';
                                    } else if (lastMonth === 8) {
                                        lastMonthConvert = 'Aug';
                                    } else if (lastMonth === 9) {
                                        lastMonthConvert = 'Sep';
                                    } else if (lastMonth === 10) {
                                        lastMonthConvert = 'Oct';
                                    } else if (lastMonth === 11) {
                                        lastMonthConvert = 'Nov';
                                    } else if (lastMonth === 12) {
                                        lastMonthConvert = 'Dec';
                                    }

                                    let AcademicYearMonthYearTemp = {
                                        prop: lastMonthConvert,
                                        label: lastMonthConvert,
                                    };

                                    this.studentLearningMomentProgressListValue.push(AcademicYearMonthYearTemp);
                                }
                            }
                            //arrange the month to year

                            //posted report
                            if (Object.keys(response.PostedInfo).length > 0) {
                                response.PostedInfo.GroupByDomain.forEach(gbdItem => {
                                    let currentDomain = gbdItem.Domain;

                                    //insert domain
                                    let newRow = {
                                        'Domain': gbdItem.Domain,
                                        'isDomain': true,
                                        'Jan': [],
                                        'Feb': [],
                                        'Mar': [],
                                        'Apr': [],
                                        'May': [],
                                        'Jun': [],
                                        'Jul': [],
                                        'Aug': [],
                                        'Sep': [],
                                        'Oct': [],
                                        'Nov': [],
                                        'Dec': [],
                                    };
                                    this.studentLearningMomentProgressList.push(newRow);
                                    //insert domain

                                    //insert goals and key skill or CLD
                                    response.PostedInfo.GroupByDomainGoals.forEach(gbdgItem => {
                                        if (currentDomain === gbdgItem.Domain) {
                                            let currentGoals = gbdgItem.Goals;
                                            let jan = [], feb = [], mar = [], apr = [], may = [], jun = [], jul = [], aug = [], sep = [], oct = [], nov = [], dec = [];

                                            response.PostedInfo.All.forEach(allItem => {
                                                if (currentDomain === allItem.Domain && currentGoals === allItem.Goals) {
                                                    let newIndicator = {
                                                        'PostID': allItem['PosID'],
                                                        'Value': allItem['Indicator'],
                                                    };

                                                    if (allItem.Month === 1) {
                                                        jan.push(newIndicator);
                                                    } else if (allItem.Month === 2) {
                                                        feb.push(newIndicator);
                                                    } else if (allItem.Month === 3) {
                                                        mar.push(newIndicator);
                                                    } else if (allItem.Month === 4) {
                                                        apr.push(newIndicator);
                                                    } else if (allItem.Month === 5) {
                                                        may.push(newIndicator);
                                                    } else if (allItem.Month === 6) {
                                                        jun.push(newIndicator);
                                                    } else if (allItem.Month === 7) {
                                                        jul.push(newIndicator);
                                                    } else if (allItem.Month === 8) {
                                                        aug.push(newIndicator);
                                                    } else if (allItem.Month === 9) {
                                                        sep.push(newIndicator);
                                                    } else if (allItem.Month === 10) {
                                                        oct.push(newIndicator);
                                                    } else if (allItem.Month === 11) {
                                                        nov.push(newIndicator);
                                                    } else if (allItem.Month === 12) {
                                                        dec.push(newIndicator);
                                                    }
                                                }
                                            });

                                            let newRow = {
                                                'Domain': currentGoals,
                                                'isDomain': false,
                                                'Jan': jan,
                                                'Feb': feb,
                                                'Mar': mar,
                                                'Apr': apr,
                                                'May': may,
                                                'Jun': jun,
                                                'Jul': jul,
                                                'Aug': aug,
                                                'Sep': sep,
                                                'Oct': oct,
                                                'Nov': nov,
                                                'Dec': dec,
                                            };
                                            this.studentLearningMomentProgressList.push(newRow);
                                        }
                                    });
                                    //insert goals and key skill or CLD
                                });
                            }
                            //posted report
                            /*#endregion*/

                            /*#region chart and details whole year*/
                            //assigned planner list details
                            if (Object.keys(response.PlannerInfo).length > 0) {
                                response.PlannerInfo.AssignedPlannerDetials.forEach(plannerAssignedListInt => {
                                    let doneTime = 0;

                                    if (Object.keys(response.PostedInfo).length > 0) {
                                        response.PostedInfo.All.forEach(allItem => {
                                            if (plannerAssignedListInt.PlnStaDomain === allItem.Domain && plannerAssignedListInt.PlnStaGoals === allItem.Goals && plannerAssignedListInt.PlnStaIndicator === allItem.Indicator) {
                                                doneTime ++;
                                            }
                                        });
                                    }

                                    let newRow = {
                                        'Domain': plannerAssignedListInt.PlnStaDomain,
                                        'Goals': plannerAssignedListInt.PlnStaGoals,
                                        'Indicator': plannerAssignedListInt.PlnStaIndicator,
                                        'Done': doneTime,
                                    };
                                    this.plannerAssignedListInt.push(newRow);
                                });
                            }
                            //assigned planner list details

                            //posted domain
                            if (Object.keys(response.PlannerInfo).length > 0) {
                                response.PlannerInfo.AssignedPlannerGroupByDomainCount.forEach(assignedPlannerGroupByDomainCountItem => {
                                    let currentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let postedCount = 0;
                                    let mapCurrentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let subCurrentDomain = false;
                                    let gotSubCurrentDomain = false;

                                    if(response.DomainMapping.Table.length > 0){
                                        response.DomainMapping.Table.forEach(domainMappingItem => {
                                            if (currentDomain === domainMappingItem.PlnDpMmMain) {
                                                mapCurrentDomain = mapCurrentDomain + ' ' + domainMappingItem.PlnDpMmSub;
                                                gotSubCurrentDomain = true;
                                            }

                                            if (currentDomain === domainMappingItem.PlnDpMmSub) {
                                                subCurrentDomain = true;
                                            }
                                        });
                                    }

                                    if (!subCurrentDomain) {
                                        this.plannerAssignedListInt.forEach(plannerAssignedListIntItem => {
                                            if (currentDomain === plannerAssignedListIntItem.Domain && plannerAssignedListIntItem.Done > 0) {
                                                postedCount ++;
                                            } else if (gotSubCurrentDomain && plannerAssignedListIntItem.Done > 0) {
                                                response.DomainMapping.Table.forEach(domainMappingItem => {
                                                    if (currentDomain === domainMappingItem.PlnDpMmMain && plannerAssignedListIntItem.Domain === domainMappingItem.PlnDpMmSub) {
                                                        postedCount ++;
                                                    }
                                                });
                                            }
                                        });

                                        if (postedCount > 0) {
                                            let donePercentage = 0;
                                            donePercentage = (postedCount * 100) / assignedPlannerGroupByDomainCountItem.Total;
                                            donePercentage = parseFloat(parseFloat(donePercentage).toFixed(2));

                                            let newRow = {
                                                'Domain': mapCurrentDomain,
                                                'PostedCount': postedCount,
                                                'Total': assignedPlannerGroupByDomainCountItem.Total,
                                                'DonePercentage': donePercentage,
                                            };
                                            this.postedDomainSummary.push(newRow);
                                        }
                                    }
                                });

                                let colorIndexPosted = 0;
                                let colorHoverIndexPosted = 0;
                                this.postedDomainSummary.forEach(assignedPlannerGroupByDomainPostedItem => {
                                    this.postedDomainChart.labels.push(assignedPlannerGroupByDomainPostedItem.Domain);

                                    this.postedDomainChart.datasets[0].data.push(assignedPlannerGroupByDomainPostedItem.PostedCount);
                                    this.postedDomainChart.datasets[0].backgroundColor.push(this.ChartBG[colorIndexPosted]);
                                    this.postedDomainChart.datasets[0].hoverBackgroundColor.push(this.HoverChartBG[colorHoverIndexPosted]);
                                    this.postedDomainChart.datasets[0].label = 'Domains';

                                    if (colorIndexPosted <= this.ChartBG.length) {
                                        colorIndexPosted ++;
                                    } else {
                                        colorIndexPosted = 0;
                                    }

                                    if (colorHoverIndexPosted <= this.HoverChartBG.length) {
                                        colorHoverIndexPosted ++;
                                    } else {
                                        colorHoverIndexPosted = 0;
                                    }
                                });

                                this.plannerAssignedListInt.forEach(plannerAssignedListIntItem => {
                                    if (plannerAssignedListIntItem.Done>0){
                                        this.postedDomainDetailsInt.push(plannerAssignedListIntItem);
                                    }
                                });
                            }
                            //posted domain

                            //pending domain
                            if (Object.keys(response.PlannerInfo).length > 0) {
                                response.PlannerInfo.AssignedPlannerGroupByDomainCount.forEach(assignedPlannerGroupByDomainCountItem => {
                                    let currentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let pendingCount = assignedPlannerGroupByDomainCountItem.Total;
                                    let mapCurrentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let subCurrentDomain = false;
                                    let gotSubCurrentDomain = false;

                                    if(response.DomainMapping.Table.length > 0){
                                        response.DomainMapping.Table.forEach(domainMappingItem => {
                                            if (currentDomain === domainMappingItem.PlnDpMmMain) {
                                                mapCurrentDomain = mapCurrentDomain + ' ' + domainMappingItem.PlnDpMmSub;
                                                gotSubCurrentDomain = true;
                                            }

                                            if (currentDomain === domainMappingItem.PlnDpMmSub) {
                                                subCurrentDomain = true;
                                            }
                                        });
                                    }

                                    if (!subCurrentDomain) {
                                        this.plannerAssignedListInt.forEach(plannerAssignedListIntItem => {
                                            if (currentDomain === plannerAssignedListIntItem.Domain && plannerAssignedListIntItem.Done > 0) {
                                                pendingCount --;
                                            } else if (gotSubCurrentDomain && plannerAssignedListIntItem.Done > 0) {
                                                response.DomainMapping.Table.forEach(domainMappingItem => {
                                                    if (currentDomain === domainMappingItem.PlnDpMmMain && plannerAssignedListIntItem.Domain === domainMappingItem.PlnDpMmSub) {
                                                        pendingCount --;
                                                    }
                                                });
                                            }
                                        });

                                        if (pendingCount > 0) {
                                            let undonePercentage = 0;
                                            undonePercentage = (pendingCount * 100) / assignedPlannerGroupByDomainCountItem.Total;
                                            undonePercentage = parseFloat(parseFloat(undonePercentage).toFixed(2));

                                            let newRow = {
                                                'Domain': mapCurrentDomain,
                                                'PendingCount': pendingCount,
                                                'Total': assignedPlannerGroupByDomainCountItem.Total,
                                                'UnDonePercentage': undonePercentage,
                                            };
                                            this.pendingDomainSummary.push(newRow);
                                        }
                                    }
                                });

                                let colorIndexPending = 0;
                                let colorHoverIndexPending = 0;
                                this.pendingDomainSummary.forEach(assignedPlannerGroupByDomainPendingItem => {
                                    this.pendingDomainChart.labels.push(assignedPlannerGroupByDomainPendingItem.Domain);

                                    this.pendingDomainChart.datasets[0].data.push(assignedPlannerGroupByDomainPendingItem.PendingCount);
                                    this.pendingDomainChart.datasets[0].backgroundColor.push(this.ChartBG[colorIndexPending]);
                                    this.pendingDomainChart.datasets[0].hoverBackgroundColor.push(this.HoverChartBG[colorHoverIndexPending]);
                                    this.pendingDomainChart.datasets[0].label = 'Domains';

                                    if (colorIndexPending <= this.ChartBG.length) {
                                        colorIndexPending ++;
                                    } else {
                                        colorIndexPending = 0;
                                    }

                                    if (colorHoverIndexPending <= this.HoverChartBG.length) {
                                        colorHoverIndexPending ++;
                                    } else {
                                        colorHoverIndexPending = 0;
                                    }
                                });

                                this.plannerAssignedListInt.forEach(plannerAssignedListIntItem => {
                                    if (plannerAssignedListIntItem.Done<1){
                                        this.pendingDomainDetailsInt.push(plannerAssignedListIntItem);
                                    }
                                });
                            }
                            //pending domain
                            /*#endregion*/

                            /*#region chart and details by term*/
                            //assigned planner list details
                            if (Object.keys(response.PlannerInfoByTerm).length > 0) {
                                response.PlannerInfoByTerm.AssignedPlannerDetials.forEach(plannerAssignedListInt => {
                                    let doneTime = 0;

                                    if (Object.keys(response.PostedInfoByTerm).length > 0) {
                                        response.PostedInfoByTerm.All.forEach(allItem => {
                                            if (plannerAssignedListInt.PlnStaDomain === allItem.Domain && plannerAssignedListInt.PlnStaGoals === allItem.Goals && plannerAssignedListInt.PlnStaIndicator === allItem.Indicator) {
                                                doneTime ++;
                                            }
                                        });
                                    }

                                    let newRow = {
                                        'Domain': plannerAssignedListInt.PlnStaDomain,
                                        'Goals': plannerAssignedListInt.PlnStaGoals,
                                        'Indicator': plannerAssignedListInt.PlnStaIndicator,
                                        'Done': doneTime,
                                    };
                                    this.plannerAssignedByTermListInt.push(newRow);
                                });
                            }
                            //assigned planner list details

                            //posted domain
                            if (Object.keys(response.PlannerInfoByTerm).length > 0) {
                                response.PlannerInfoByTerm.AssignedPlannerGroupByDomainCount.forEach(assignedPlannerGroupByDomainCountItem => {
                                    let currentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let postedCount = 0;
                                    let mapCurrentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let subCurrentDomain = false;
                                    let gotSubCurrentDomain = false;

                                    if(response.DomainMapping.Table.length > 0){
                                        response.DomainMapping.Table.forEach(domainMappingItem => {
                                            if (currentDomain === domainMappingItem.PlnDpMmMain) {
                                                mapCurrentDomain = mapCurrentDomain + ' ' + domainMappingItem.PlnDpMmSub;
                                                gotSubCurrentDomain = true;
                                            }

                                            if (currentDomain === domainMappingItem.PlnDpMmSub) {
                                                subCurrentDomain = true;
                                            }
                                        });
                                    }

                                    if (!subCurrentDomain) {
                                        this.plannerAssignedByTermListInt.forEach(plannerAssignedListIntItem => {
                                            if (currentDomain === plannerAssignedListIntItem.Domain && plannerAssignedListIntItem.Done > 0) {
                                                postedCount ++;
                                            } else if (gotSubCurrentDomain && plannerAssignedListIntItem.Done > 0) {
                                                response.DomainMapping.Table.forEach(domainMappingItem => {
                                                    if (currentDomain === domainMappingItem.PlnDpMmMain && plannerAssignedListIntItem.Domain === domainMappingItem.PlnDpMmSub) {
                                                        postedCount ++;
                                                    }
                                                });
                                            }
                                        });

                                        if (postedCount > 0) {
                                            let donePercentage = 0;
                                            donePercentage = (postedCount * 100) / assignedPlannerGroupByDomainCountItem.Total;
                                            donePercentage = parseFloat(parseFloat(donePercentage).toFixed(2));

                                            let newRow = {
                                                'Domain': mapCurrentDomain,
                                                'PostedCount': postedCount,
                                                'Total': assignedPlannerGroupByDomainCountItem.Total,
                                                'DonePercentage': donePercentage,
                                            };
                                            this.postedDomainByTermSummary.push(newRow);
                                        }
                                    }
                                });

                                let colorIndexPosted = 0;
                                let colorHoverIndexPosted = 0;
                                this.postedDomainByTermSummary.forEach(assignedPlannerGroupByDomainPostedItem => {
                                    this.postedDomainByTermChart.labels.push(assignedPlannerGroupByDomainPostedItem.Domain);

                                    this.postedDomainByTermChart.datasets[0].data.push(assignedPlannerGroupByDomainPostedItem.PostedCount);
                                    this.postedDomainByTermChart.datasets[0].backgroundColor.push(this.ChartBG[colorIndexPosted]);
                                    this.postedDomainByTermChart.datasets[0].hoverBackgroundColor.push(this.HoverChartBG[colorHoverIndexPosted]);
                                    this.postedDomainByTermChart.datasets[0].label = 'Domains';

                                    if (colorIndexPosted <= this.ChartBG.length) {
                                        colorIndexPosted ++;
                                    } else {
                                        colorIndexPosted = 0;
                                    }

                                    if (colorHoverIndexPosted <= this.HoverChartBG.length) {
                                        colorHoverIndexPosted ++;
                                    } else {
                                        colorHoverIndexPosted = 0;
                                    }
                                });

                                this.plannerAssignedByTermListInt.forEach(plannerAssignedListIntItem => {
                                    if (plannerAssignedListIntItem.Done>0){
                                        this.postedDomainByTermDetailsInt.push(plannerAssignedListIntItem);
                                    }
                                });
                            }
                            //posted domain

                            //pending domain
                            if (Object.keys(response.PlannerInfoByTerm).length > 0) {
                                response.PlannerInfoByTerm.AssignedPlannerGroupByDomainCount.forEach(assignedPlannerGroupByDomainCountItem => {
                                    let currentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let pendingCount = assignedPlannerGroupByDomainCountItem.Total;
                                    let mapCurrentDomain = assignedPlannerGroupByDomainCountItem.Domain;
                                    let subCurrentDomain = false;
                                    let gotSubCurrentDomain = false;

                                    if(response.DomainMapping.Table.length > 0){
                                        response.DomainMapping.Table.forEach(domainMappingItem => {
                                            if (currentDomain === domainMappingItem.PlnDpMmMain) {
                                                mapCurrentDomain = mapCurrentDomain + ' ' + domainMappingItem.PlnDpMmSub;
                                                gotSubCurrentDomain = true;
                                            }

                                            if (currentDomain === domainMappingItem.PlnDpMmSub) {
                                                subCurrentDomain = true;
                                            }
                                        });
                                    }

                                    if (!subCurrentDomain) {
                                        this.plannerAssignedByTermListInt.forEach(plannerAssignedListIntItem => {
                                            if (currentDomain === plannerAssignedListIntItem.Domain && plannerAssignedListIntItem.Done > 0) {
                                                pendingCount --;
                                            } else if (gotSubCurrentDomain && plannerAssignedListIntItem.Done > 0) {
                                                response.DomainMapping.Table.forEach(domainMappingItem => {
                                                    if (currentDomain === domainMappingItem.PlnDpMmMain && plannerAssignedListIntItem.Domain === domainMappingItem.PlnDpMmSub) {
                                                        pendingCount --;
                                                    }
                                                });
                                            }
                                        });

                                        if (pendingCount > 0) {
                                            let undonePercentage = 0;
                                            undonePercentage = (pendingCount * 100) / assignedPlannerGroupByDomainCountItem.Total;
                                            undonePercentage = parseFloat(parseFloat(undonePercentage).toFixed(2));

                                            let newRow = {
                                                'Domain': mapCurrentDomain,
                                                'PendingCount': pendingCount,
                                                'Total': assignedPlannerGroupByDomainCountItem.Total,
                                                'UnDonePercentage': undonePercentage,
                                            };
                                            this.pendingDomainByTermSummary.push(newRow);
                                        }
                                    }
                                });

                                let colorIndexPending = 0;
                                let colorHoverIndexPending = 0;
                                this.pendingDomainByTermSummary.forEach(assignedPlannerGroupByDomainPendingItem => {
                                    this.pendingDomainByTermChart.labels.push(assignedPlannerGroupByDomainPendingItem.Domain);

                                    this.pendingDomainByTermChart.datasets[0].data.push(assignedPlannerGroupByDomainPendingItem.PendingCount);
                                    this.pendingDomainByTermChart.datasets[0].backgroundColor.push(this.ChartBG[colorIndexPending]);
                                    this.pendingDomainByTermChart.datasets[0].hoverBackgroundColor.push(this.HoverChartBG[colorHoverIndexPending]);
                                    this.pendingDomainByTermChart.datasets[0].label = 'Domains';

                                    if (colorIndexPending <= this.ChartBG.length) {
                                        colorIndexPending ++;
                                    } else {
                                        colorIndexPending = 0;
                                    }

                                    if (colorHoverIndexPending <= this.HoverChartBG.length) {
                                        colorHoverIndexPending ++;
                                    } else {
                                        colorHoverIndexPending = 0;
                                    }
                                });

                                this.plannerAssignedByTermListInt.forEach(plannerAssignedListIntItem => {
                                    if (plannerAssignedListIntItem.Done<1){
                                        this.pendingDomainByTermDetailsInt.push(plannerAssignedListIntItem);
                                    }
                                });
                            }
                            //pending domain
                            /*#endregion*/

                            /*#region data table naming*/
                            let IB = false;

                            if (Cookies.get('schoolSession') === 'SCH201400000553') {
                                if (this.currentLevelType === 'N2' || this.currentLevelType === 'K1' || this.currentLevelType === 'K2') {
                                    IB = true;
                                }
                            }

                            if (Cookies.get('schoolSession') === 'SCH201400000553') {
                                if (this.currentLevelType === 'N2' || this.currentLevelType === 'K1' || this.currentLevelType === 'K2') {
                                    this.viewDomainDetails = [{
                                        prop: "Domain",
                                        label: lang("Subject Focus")
                                    }, {
                                        prop: "Goals",
                                        label: lang("Subject Area")
                                    }, {
                                        prop: "Indicator",
                                        label: lang("Learning Goals")
                                    }, {
                                        prop: "Done",
                                        label: lang("Done")
                                    }];
                                } else if (this.currentLevelType === 'PN' ||  this.currentLevelType === 'N1') {
                                    this.viewDomainDetails = [{
                                        prop: "Domain",
                                        label: lang("Areas of Learning")
                                    }, {
                                        prop: "Goals",
                                        label: lang("Learning Focus")
                                    }, {
                                        prop: "Indicator",
                                        label: lang("Learning Goals")
                                    }, {
                                        prop: "Done",
                                        label: lang("Done")
                                    }];
                                }
                            } else {
                                this.viewDomainDetails = [{
                                    prop: "Domain",
                                    label: lang("Domain")
                                }, {
                                    prop: "Goals",
                                    label: lang("Goals")
                                }, {
                                    prop: "Indicator",
                                    label: lang("Indicator")
                                }, {
                                    prop: "Done",
                                    label: lang("Done")
                                }];
                            }
                            /*#endregion*/
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            async displayPost (postID) {
                this.$vs.loading();

                const response = await DataSource.shared.getPlannerProgressPost(postID);
                if (response) {
                    if (response.code === '88') {
                        window.location.replace('/');
                    } else if (response.code === '99') {
                        console.log('Get Planner Progress Post: Error');
                    } else if (response.code === '2') {
                        console.log('Get Planner Progress Post: No Record');
                    } else {
                        this.postIDList = response;
                        this.$refs.postModal.show();
                    }
                }

                this.$vs.loading.close();
            },
            async getAllSemesterAndSemesterDetails (postID) {
                try {
                    const response = await DataSource.shared.getAllHistorySemesterAndSemesterDetailsByStudentID(this.currentStudentID);

                    if (response) {
                        if (response.code === '88') {
                            window.location.replace('/');
                        } else if (response.code === '99') {
                            this.$notify.error({
                                title: 'Error',
                                message: 'Error: Get All History Semester And Semester Details By Student ID'
                            });
                        } else if (response.code === '2') {
                            this.$notify({
                                title: 'No Record',
                                message: 'No Record Found...'
                            });
                        } else {
                            this.ddlSemesterList = response.Semester;
                            this.ddlSemesterDetailsFullList = response.SemesterDetails;
                        }
                    }
                } catch (e) {
                    this.results = e;
                }
            },
            openPendingDomainDetailsModal () {
                this.$refs.pendingDomainDetailsModal.show();
            },
            openPostedDomainDetailsModal () {
                this.$refs.postedDomainDetailsModal.show();
            },
            openPendingDomainByTermDetailsModal () {
                this.$refs.pendingDomainByTermDetailsModal.show();
            },
            openPostedDomainByTermDetailsModal () {
                this.$refs.postedDomainByTermDetailsModal.show();
            },
            BindSemesterDetails(){
                this.studentLearningMomentProgressListRecords = false;
                this.studentLearningMomentProgressList = [];

                this.showWholeYear = false;
                this.showhideWholeYearText = 'Hide Whole Academic Year';

                this.ddlSemesterDetails = '';
                this.ddlSemesterDetailsList = [];

                this.ddlSemesterDetailsList = this.ddlSemesterDetailsFullList.filter(data => data.SemesterID === this.ddlSemester);
            },
            ChangeSemesterDetails(){
                this.studentLearningMomentProgressListRecords = false;
                this.showWholeYear = false;
                this.showhideWholeYearText = 'Show Whole Academic Year';

                //dataset reset
                this.studentLearningMomentProgressList = [];
                this.studentLearningMomentProgressListValue = [];

                this.plannerAssignedListInt = [];
                this.pendingDomainSummary = [];
                this.pendingDomainDetailsInt = [];
                this.postedDomainSummary = [];
                this.postedDomainDetailsInt = [];

                this.plannerAssignedByTermListInt = [];
                this.postedDomainByTermSummary = [];
                this.postedDomainByTermDetailsInt = [];
                this.pendingDomainByTermSummary = [];
                this.pendingDomainByTermDetailsInt = [];
                //dataset reset

                //chart reset
                let pendingDomainChart = {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                };

                let postedDomainChart = {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                };

                let pendingDomainByTermChart = {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                };

                let postedDomainByTermChart = {
                    labels: [],
                    datasets: [{
                        data: [],
                        backgroundColor: [],
                        hoverBackgroundColor: [],
                    }],
                };

                this.pendingDomainChart = pendingDomainChart;
                this.postedDomainChart = postedDomainChart;

                this.pendingDomainByTermChart = pendingDomainByTermChart;
                this.postedDomainByTermChart = postedDomainByTermChart;
                //chart reset

                this.getStudentPlannerProgressByClassIDRange('');
            },
            showhideWholeYear(){
                if (this.showWholeYear) {
                    this.showWholeYear = false;
                    this.showhideWholeYearText = 'Show Whole Academic Year';
                } else {
                    this.showWholeYear = true;
                    this.showhideWholeYearText = 'Hide Whole Academic Year';
                }
            }
        },

        props: ["ppParamData","studentID","classID","semdID","levelType","StudentFullName"  ],
    }
</script>

<style scoped>
    .studentLearningMomentProgressTable {
        max-width: 100%;
        max-height: 700px;
        overflow: scroll;
        position: relative;
    }

    .studentLearningMomentProgressTable table {
        position: relative;
        border-collapse: collapse;
    }

    .studentLearningMomentProgressTable td, .studentLearningMomentProgressTable th {
        padding: 15px;
        min-width: 300px;
    }

    .studentLearningMomentProgressTable thead th {
        position: -webkit-sticky; /* for Safari */
        position: sticky;
        top: 0;
        background: #FFF;
        outline: 1px solid #e9ecef;
        border:none;
        outline-offset: -1px;
    }

    .studentLearningMomentProgressTable thead th:first-child {
        left: -1px;
        z-index: 1;
        background: #FFF;
    }

    .studentLearningMomentProgressTable tbody td:first-child {
        position: -webkit-sticky; /* for Safari */
        position: sticky;
        left: -1px;
        background: #FFF;
        border-right: 1px solid #CCC;
    }

    .studentLearningMomentProgressTable .IndicatorSpan {
        background: #C9F1FD;
        color: #0C59CF;
        margin-right: 15px;
        padding: 5px;
        display: inline-block;
        max-width: 280px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        cursor: pointer;
    }

    .studentLearningMomentProgressTable .domainDiv {
        color: #1464F6;
        font-weight: bold;
    }

    .studentLearningMomentProgressTable .domainTr {
        border-top: 1px black solid;
    }

    .postedReportDiv {
        margin-top: 100px;
    }

    .partTitle {
        text-decoration: underline;
    }

    .actionDiv {
        text-align: right;
    }

    .divWholeYear {
        background-color: #D3D3D3;
        padding: 20px;
        margin: 0 20px 50px 20px;
        border-radius: 25px;
    }

    .divBtnShowhideWholeYear {
        text-align: left;
        margin-bottom: 10px;
    }

    .radarChart {
        margin: 50px 0;
        overflow: auto;
        background-color: white;
    }
</style>